/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_HelpInputs */

const en_footer_action_help = /** @type {(inputs: Footer_Action_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you can help`)
};

/**
* | output |
* | --- |
* | "How you can help" |
*
* @param {Footer_Action_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_help = /** @type {((inputs?: Footer_Action_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_help(inputs)
});